import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Button } from './ui/Button';
const CALENDAR_URL = 'https://calendar.app.google/PYPdcRoYne7QrNJA7';
const HERO_IMAGE_URL = 'https://cdn.magicpatterns.com/uploads/pKeem7v1A62iqVeaFZJdzX/heylloyd-image-1773419847413.png';
export function Hero() {
  const painPoints = ['Si en días de semana el restaurante está vacío aunque el fin de semana esté lleno', 'Si dependes de que la gente "pase por enfrente" para entrar', 'Si tus promociones de descuento atraen gente que gasta poco y no vuelve sin otro descuento', 'Si no tienes un sistema de reservas online y las mesas se quedan vacías', 'Si tu competencia aparece primero en Google Maps y en Yelp aunque tu comida sea mejor'];
  const scrollToContact = () => {
    document.getElementById('contacto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-12 pb-16 md:pt-24 md:pb-24 px-4 border-b border-gray-900 overflow-hidden" data-id="element-192">
      <div className="max-w-7xl mx-auto" data-id="element-193">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-194">
          {/* Text Content */}
          <div className="flex-1 w-full order-2 lg:order-1" data-id="element-195">
            <div className="mb-10" data-id="element-196">
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold tracking-tight mb-6 leading-tight" data-id="element-197">
                ¿Tu restaurante tiene mesas vacías{' '}
                <br className="hidden md:block" data-id="element-198" />
                mientras el de enfrente{' '}
                <span className="text-gold" data-id="element-199">tiene lista de espera?</span>
              </h1>
              <p className="text-lg md:text-xl text-gray-400 max-w-2xl leading-relaxed" data-id="element-200">
                No es la comida. Es el sistema. Llenamos tu restaurante de
                comensales que reservan con anticipación, gastan más por visita
                y regresan una y otra vez.
              </p>
            </div>

            <div className="bg-gray-900/30 border border-gray-800 p-6 md:p-8 rounded-sm mb-10" data-id="element-201">
              <p className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-6" data-id="element-202">
                Identifica tu situación:
              </p>
              <ul className="space-y-4" data-id="element-203">
                {painPoints.map((point, index) => <li key={index} className="flex items-start" data-id="element-204">
                    <CheckCircle2 className="w-6 h-6 text-emerald shrink-0 mr-4 mt-0.5" data-id="element-205" />
                    <span className="text-gray-300 text-base md:text-lg" data-id="element-206">
                      {point}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="flex flex-col items-start" data-id="element-207">
              <Button onClick={scrollToContact} className="w-full md:w-auto shadow-[0_0_30px_rgba(242,183,5,0.15)] animate-pulse" data-id="element-208">
                QUIERO MI RESTAURANTE LLENO
              </Button>
              <a href={CALENDAR_URL} target="_blank" rel="noopener noreferrer" className="mt-4 text-sm text-gray-400 hover:text-gold transition-colors flex items-center gap-1 self-center md:self-start" data-id="element-209">
                O agenda directamente →
              </a>
            </div>
          </div>

          {/* Image Content */}
          <div className="flex-1 w-full order-1 lg:order-2" data-id="element-210">
            <div className="relative rounded-lg overflow-hidden border border-gray-800 shadow-2xl" data-id="element-211">
              <div className="absolute inset-0 bg-gradient-to-t from-carbon/80 to-transparent z-10 lg:hidden" data-id="element-212"></div>
              <img src={HERO_IMAGE_URL} alt="Chef cocinando y cliente recibiendo comida de un food truck" className="w-full h-[300px] lg:h-[600px] object-cover object-center" data-id="element-213" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}